export const LEAVE_TYPE_FILTER_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Casual Leave', value: 'Casual Leave' },
  { label: 'Sick Leave', value: 'Sick Leave' },
  { label: 'Earned Leave', value: 'Earned Leave' },
  { label: 'Maternity Leave', value: 'Maternity Leave' },
  { label: 'Compensatory Off', value: 'Compensatory Off' },
  { label: 'Loss of Pay', value: 'Loss of Pay' },
]

export const LEAVE_STATUS_FILTER_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Rejected', value: 'REJECTED' },
]

export const LEAVE_DATE_FILTER_OPTIONS = [
  { label: 'All Dates', value: 'All Dates' },
  { label: 'Today', value: 'Today' },
  { label: 'This Week', value: 'This Week' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Upcoming', value: 'Upcoming' },
]

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export function formatDateDisplay(dateStr?: string): string {
  if (!dateStr) return '—'
  const clean = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr
  const parts = clean.split('-')
  if (parts.length !== 3) return dateStr
  const y = parseInt(parts[0], 10)
  const m = parseInt(parts[1], 10)
  const d = parseInt(parts[2], 10)
  if (isNaN(y) || isNaN(m) || isNaN(d)) return dateStr
  const monthName = MONTH_NAMES[m - 1] || `${m}`
  const dayPadded = d < 10 ? `0${d}` : `${d}`
  return `${dayPadded} ${monthName} ${y}`
}

export function calculateDays(from?: string, to?: string): string {
  if (!from || !to) return '—'
  const cleanFrom = from.includes('T') ? from.split('T')[0] : from
  const cleanTo = to.includes('T') ? to.split('T')[0] : to
  const [fY, fM, fD] = cleanFrom.split('-').map(Number)
  const [tY, tM, tD] = cleanTo.split('-').map(Number)
  if (isNaN(fY) || isNaN(fM) || isNaN(fD) || isNaN(tY) || isNaN(tM) || isNaN(tD)) return '—'
  const d1 = new Date(fY, fM - 1, fD)
  const d2 = new Date(tY, tM - 1, tD)
  const diffMs = d2.getTime() - d1.getTime()
  const days = Math.round(diffMs / (1000 * 60 * 60 * 24)) + 1
  return days === 1 ? '1 day' : `${days} days`
}

